<template>

    <v-container fluid fill-height>
        <v-layout>

            <v-flex>

               <v-card>

                   <v-breadcrumbs divider="/">
                       <v-breadcrumbs-item to="/" :disabled="false">Početna</v-breadcrumbs-item>
                       <v-breadcrumbs-item to="/costs">Unosi</v-breadcrumbs-item>
                       <v-breadcrumbs-item :disabled="true">{{ this.$route.params.day }}</v-breadcrumbs-item>
                   </v-breadcrumbs>

               </v-card>

                <v-card class="m-20" v-if="costs">

                    <v-data-table
                            :headers="headers"
                            :items="costs"
                            hide-actions
                            class="elevation-1"
                    >
                        <template slot="items" slot-scope="props">
                            <td class="text-xs-left">{{ props.item.created_at }}</td>
                            <td class="text-xs-left">{{ props.item.property.title }}</td>
                            <td class="text-xs-left">{{ props.item.attribute.title }}</td>
                            <td class="text-xs-left">{{ props.item.value }}</td>
                            <td class="text-xs-right">

                                <v-tooltip bottom>
                                    <!--<v-btn slot="activator" small color="secondary" class="black&#45;&#45;text" :to="'/users/' + props.item.id + '/edit'" v-if="checkGuard('user-edit')">-->
                                    <v-btn slot="activator" small color="secondary" class="black--text" :to="'/costs/' + props.item.id + '/edit'">
                                        <v-icon>edit</v-icon>
                                    </v-btn>
                                    <span>Izmeni</span>
                                </v-tooltip>

                                <v-tooltip bottom>
                                    <!--<v-btn slot="activator" small color="error" @click="destroy(props.item)" v-if="checkGuard('user-delete')">-->
                                    <v-btn slot="activator" small color="error" @click="destroy(props.item)">
                                        <v-icon>delete</v-icon>
                                    </v-btn>
                                    <span>Obriši</span>
                                </v-tooltip>

                            </td>
                        </template>

                    </v-data-table>

                </v-card>

            </v-flex>

            <!--<v-fab-transition v-if="checkGuard('user-create')">-->
            <v-fab-transition>

                <v-btn :color="'primary'" dark fab fixed bottom right to="/costs/create">
                    <v-icon>playlist_add</v-icon>
                    <v-icon>close</v-icon>
                </v-btn>

            </v-fab-transition>


        </v-layout>
    </v-container>

</template>

<script>
    import swal from 'sweetalert2';

    export default {
        data() {
            return {
                loading: true,
                pagination: {
                    descending: true,
                },
                costs: false,
                headers: [
                    {text: 'DATUM', align: 'left', sortable: true, value: 'created_at'},
                    {text: 'GRUPA', align: 'left', sortable: true, value: 'property_id'},
                    {text: 'POD GRUPA', align: 'left', sortable: true, value: 'attribute_id'},
                    {text: 'BILANS', sortable: true, value: 'sum'},
                    {text: 'AKCIJA', align: 'right', value: 'action'},
                ],
            }
        },
        mounted() {
            this.getCosts();
            // this.getDays();
        },
        computed: {
            user(){
                return this.$store.getters['user/getUser'];
            },
        },
        methods: {
            getCosts() {
                this.loading = true;

                axios.get('costs/' + this.$route.params.day + '/lists')
                    .then(res => {
                        this.costs = res.data.costs;
                        console.log(this.costs);
                        this.loading = false;
                    }).catch(e => {
                        console.log(e.response);
                        this.error = e.response.data.errors;
                    });
            },
            checkGuard(name){
                let res = false;
                let permissionList = this.$store.getters['ability/getPermissionList'];
                permissionList.forEach(permission => {
                    if(name === permission.name){
                        res = true;
                    }
                });
                return res;
            },
          destroy(row){
            swal({
              title: 'Da li ste sigurni?',
              text: 'Nećete moći da povratite radnju',
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: this.$vuetify.theme.primary,
              cancelButtonColor: this.$vuetify.theme.secondary,
              confirmButtonText: 'Da, obriši.',
              cancelButtonText: 'Odustani',
            }).then((result) => {
              if (result.value) {
                axios.delete('costs/' + row.id)
                  .then(res => {
                    this.getCosts();
                    swal(
                      'Obrisano',
                      'Uspešno ste obrisali',
                      'success',
                    );
                  })
                  .catch(e => {
                    console.log(e);
                  });
              }
            });
          },
        },
        watch: {
            pagination: {
                handler () {
                    this.getCosts();
                },
                deep: true
            },
        },
    }
</script>

<style scoped>
    .swal2-styled.swal2-confirm{
        border-radius: 0 !important;
    }
</style>
